module.exports = __webpack_public_path__ + "static/media/grace.3c890b7b.jpg";